import { FiSearch, FiX } from 'react-icons/fi';
import { FILTERS, ACTIONS } from '../../constants/labels';
import styles from './OfferingsPage.module.css';

export default function OfferingsFilters({
  years, categories,
  filterYear, filterStatus, filterCat, filterMember, filterFromDate, filterToDate,
  minDate, maxDate, showStatusFilter = true,
  onYearChange, onStatusChange, onCatChange, onMemberChange, onFromDateChange, onToDateChange,
  onClearFilters,
}) {
  return (
    <div className={styles.filterBar}>
      <div className="form-group" style={{ marginBottom: 0 }}>
        <select value={filterYear} onChange={(e) => onYearChange(e.target.value)}>
          <option value="">{FILTERS.allYears}</option>
          <option value="opening">Opening</option>
          {years.map((y) => <option key={y.id} value={y.id}>{y.yearLabel}</option>)}
        </select>
      </div>

      {showStatusFilter && (
        <div className="form-group" style={{ marginBottom: 0 }}>
          <select value={filterStatus} onChange={(e) => onStatusChange(e.target.value)}>
            <option value="">{FILTERS.allStatuses}</option>
            <option value="pending">Pending</option>
            <option value="partial">Partial</option>
            <option value="completed">Completed</option>
          </select>
        </div>
      )}

      <div className="form-group" style={{ marginBottom: 0 }}>
        <select value={filterCat} onChange={(e) => onCatChange(e.target.value)}>
          <option value="">{FILTERS.allCategories}</option>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      <div className="form-group" style={{ marginBottom: 0 }}>
        <div style={{ position: 'relative' }}>
          <FiSearch style={{
            position: 'absolute', left: 9, top: '50%',
            transform: 'translateY(-50%)',
            color: 'var(--color-text-muted)', pointerEvents: 'none',
          }} />
          <input
            value={filterMember}
            onChange={(e) => onMemberChange(e.target.value)}
            placeholder="Search member…"
            style={{ paddingLeft: 30 }}
          />
        </div>
      </div>

      <div className="form-group" style={{ marginBottom: 0 }}>
        <input
          type="date"
          value={filterFromDate}
          min={minDate || undefined}
          max={filterToDate || maxDate || undefined}
          onChange={(e) => onFromDateChange(e.target.value)}
          placeholder="From date"
          aria-label="From date"
        />
      </div>

      <div className="form-group" style={{ marginBottom: 0 }}>
        <input
          type="date"
          value={filterToDate}
          min={filterFromDate || minDate || undefined}
          max={maxDate || undefined}
          onChange={(e) => onToDateChange(e.target.value)}
          placeholder="To date"
          aria-label="To date"
        />
      </div>

      <button className="btn btn-ghost btn-sm" onClick={onClearFilters} title={ACTIONS.clearFilters}>
        <FiX /> {ACTIONS.clearFilters}
      </button>
    </div>
  );
}
